import React from 'react';
import './MaintenancePage.less';
import logo from './assets/images/logo-222x42.png';

const MaintenancePage = () => {
  return (
    <div className='maintenance-page'>
      <div className='maintenance-content'>
        <div className='maintenance-logo'>
          <img src={logo} alt='CareVirtue' />
        </div>

        <h1 className='maintenance-title'>We're under maintenance</h1>

        <p className='maintenance-subtitle'>
          We're currently making improvements to serve you better.
          <br />
          Our team is working hard to get everything back up and running.
        </p>

        <p className='maintenance-footer'>Thank you for your patience!</p>
      </div>
    </div>
  );
};

export default MaintenancePage;
